import { executeCommand } from '../Utils/SendCommandToACC';
import { isMockMode } from '../Knowledge/mockMode';
import { runWith } from '../Utils/accClient';
import { mockKioskExecuteCommand } from './mockKioskData';

/**
 * Kiosk PIN client, one function per command in the ACC contract, served by the
 * Lambda or, in mock mode, by `mockKioskData`. Errors follow the Utils/accClient
 * contract: pages branch on `error.code` (`E_PIN_WRONG`, `E_PIN_LOCKED`,
 * `E_SESSION_REQUIRED`), never on message text.
 *
 * The two kiosk commands that run before anyone is signed in go out anonymous:
 * no stored session, no Google token, no re-mint.
 */

const dispatchAnonymous = (command, args = []) =>
    (isMockMode() ? mockKioskExecuteCommand(command, args) : executeCommand(command, args, { anonymous: true }));

const dispatchSigned = (command, args = []) =>
    (isMockMode() ? mockKioskExecuteCommand(command, args) : executeCommand(command, args));

const runAnonymous = runWith(dispatchAnonymous);
const run = runWith(dispatchSigned);

export const listKioskTrainers = (gymId) => runAnonymous('list_kiosk_trainers', gymId ? [gymId] : []);
export const requestKioskSession = (name, pin) => runAnonymous('start_kiosk_session', [name, pin]);

// Manager and Admin, from a signed Google session.
export const setTrainerPin = (trainer, pin) => run('set_trainer_pin', [trainer, pin]);
export const clearTrainerPin = (trainer) => run('clear_trainer_pin', [trainer]);
export const listTrainerPins = () => run('list_trainer_pins', []);
export const listKioskSignins = (trainer, days) => run('list_kiosk_signins', [trainer || null, days || 30]);
